import { useTheme } from "@mui/material";
import dayjs from "dayjs";
import {
  PRIMARY_BLUE,
  UNKNOWN_GENDER_DARK_MODE,
  UNKNOWN_GENDER_LIGHT_MODE,
} from "../../../enums/Colors";

export function calculateAge(birthDateString, t) {
  if (birthDateString == null) {
    return null;
  }

  const birthDate = dayjs(birthDateString, "DD/MM/YYYY");
  const today = dayjs();
  const ageInYears = today.diff(birthDate, "year");
  const isBirthdayToday =
    today.month() === birthDate.month() && today.date() === birthDate.date();

  if (ageInYears < 1) {
    const ageInMonths = today.diff(birthDate, "month");
    const monthLabel = ageInMonths === 1 ? t("SingleMonth") : t("PluralMonths");
    return `${ageInMonths} ${monthLabel}`;
  }

  const isBirthdayPassedThisYear = today.isBefore(
    birthDate.add(ageInYears, "year"),
    "day",
  );

  const finalAge = isBirthdayPassedThisYear ? ageInYears - 1 : ageInYears;
  const ageLabel = "g.";

  return isBirthdayToday
    ? `${finalAge} ${ageLabel} 🎂`
    : `${finalAge} ${ageLabel}`;
}

export const genderEmojiMap = {
  male: "♂️",
  female: "♀️",
};

export function avatarColorCoding(gender, mode) {
  if (isUnknownGender(gender)) return getUnknownGenderColor(mode);
  return gender == "MALE" ? PRIMARY_BLUE : "pink";
}

// Values of the backend's PetGender enum, UNKNOWN is labelled "Other" in the UI
export const PET_GENDERS = ["MALE", "FEMALE", "UNKNOWN"];

// Older forms stored gender as a switch boolean (true = FEMALE), anything else falls back to MALE
export function normalizePetGender(gender) {
  if (typeof gender === "boolean") return gender ? "FEMALE" : "MALE";
  const upper = String(gender).toUpperCase();
  return PET_GENDERS.includes(upper) ? upper : "MALE";
}

// UNKNOWN pet gender is gray, same as the mobile app (light: dark gray, dark: light gray)
export const isUnknownGender = (gender) =>
  String(gender).toUpperCase() === "UNKNOWN";

export const getUnknownGenderColor = (mode) =>
  mode === "dark" ? UNKNOWN_GENDER_DARK_MODE : UNKNOWN_GENDER_LIGHT_MODE;

export function useUnknownGenderColor() {
  const theme = useTheme();
  return getUnknownGenderColor(theme.palette.mode);
}

// White avatar letters would be invisible on the light gray UNKNOWN background in dark mode
export const getGenderAvatarTextColor = (gender, mode, deceased = false) =>
  !deceased && isUnknownGender(gender) && mode === "dark"
    ? UNKNOWN_GENDER_LIGHT_MODE
    : "white";
